import { ReactElement } from 'react';

import {
   HealthcareFacilityLocationSpecialty,
   HealthcareFacilityLocationSpecialtyQuery,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { CqrsQueryPerformResult, performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { Slot, TextPattern } from '@dreryk/watermelon';
import { createTranslatedText, ValidationRules } from '@dreryk/react-common';

import {
   HealthcareFacilityLocationSpecialtyFormBeanPart,
   SpecialtyType,
} from './HealthcareFacilityLocationSpecialtyField.types';

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
const psychiatricHospitalWardCodes = [4700, 4701] as const;

export const isHealthcareFacilitySpecialtyPsychiatric = (
   healthcareFacilityLocationSpecialty: HealthcareFacilityLocationSpecialty
): boolean => {
   return psychiatricHospitalWardCodes.some(
      (code) => code.toString() === healthcareFacilityLocationSpecialty.code.toString()
   );
};

export const createHealthcareFacilityLocationSpecialtySearchCreator = (specialtyType: SpecialtyType) => (
   searchText: string | null
) => {
   return async (): CqrsQueryPerformResult<HealthcareFacilityLocationSpecialty[]> =>
      performCqrsQuerySearch<HealthcareFacilityLocationSpecialty>(() => {
         const query = new HealthcareFacilityLocationSpecialtyQuery();
         if (searchText) {
            query.nameOrCode = TextPattern.anywhereIgnoreCase(searchText);
         }
         query[specialtyType] = Slot.of(true);
         return query;
      });
};
export const labelExtractor = (item: HealthcareFacilityLocationSpecialty): string => item.name;

export const itemRenderer = (facilityLocationSpecialty: HealthcareFacilityLocationSpecialty): ReactElement => (
   <div>{`${facilityLocationSpecialty.name} - ${facilityLocationSpecialty.code.toString()}`}</div>
);

export const validationRules: ValidationRules<HealthcareFacilityLocationSpecialtyFormBeanPart> = {
   required: true,
   validate: (value) => {
      const currentHealthcareFacilityLocationSpecialty = value as HealthcareFacilityLocationSpecialty | null;
      if (
         currentHealthcareFacilityLocationSpecialty &&
         isHealthcareFacilitySpecialtyPsychiatric(currentHealthcareFacilityLocationSpecialty)
      ) {
         return createTranslatedText('');
      }
      return undefined;
   },
};
